import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Componente que força o scroll para o topo sempre que a rota mudar
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
